var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOphisiant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Serving Dome, Hand 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M24.6062 4.26884C25.6313 5.29397 25.6313 6.95602 24.6062 7.98115C23.581 9.00628 21.919 9.00628 20.8938 7.98115C19.8687 6.95603 19.8687 5.29398 20.8938 4.26884C21.919 3.24372 23.581 3.24372 24.6062 4.26884Z",
    stroke: "#DEB75D",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9.84375 38.5H6.78125C5.936 38.5 5.25 37.814 5.25 36.9688V27.7812C5.25 26.936 5.936 26.25 6.78125 26.25H9.84375C10.689 26.25 11.375 26.936 11.375 27.7812V36.9688C11.375 37.814 10.689 38.5 9.84375 38.5Z",
    stroke: "#DEB75D",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M20.5625 32.375H24.1343C24.7975 32.375 25.4415 32.1615 25.9717 31.7625L29.6712 28.987C30.5952 28.294 31.8867 28.3867 32.704 29.2022C33.6105 30.1087 33.6105 31.577 32.704 32.4817L29.5295 35.6562C28.6755 36.5102 27.5853 37.0947 26.4005 37.331L21.9135 38.2287C21.0245 38.4055 20.1058 38.3845 19.2255 38.164L15.1672 37.1525C14.6825 37.03 14.1837 36.9687 13.6832 36.9687H11.375",
    stroke: "#DEB75D",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M20.5625 32.375H22.8357C24.1167 32.375 25.1562 31.3372 25.1562 30.0545V29.5908C25.1562 28.5268 24.4318 27.5992 23.3993 27.342L19.8905 26.4653C19.32 26.3218 18.7338 26.25 18.1458 26.25C16.7265 26.25 15.337 26.67 14.1575 27.4575L11.375 29.3125",
    stroke: "#DEB75D",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M36.75 21H8.75",
    stroke: "#DEB75D",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M35 21C35 14.2345 29.5155 8.75 22.75 8.75C15.9845 8.75 10.5 14.2345 10.5 21",
    stroke: "#DEB75D",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOphisiant);
export default __webpack_public_path__ + "static/media/ophisiant.052b9eeddcb591894fa81d77b66ffe6c.svg";
export { ForwardRef as ReactComponent };